module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M20 10H2c-1.106 0-2 .894-2 2v18c0 1.106.894 2 2 2h18c1.106 0 2-.894 2-2V12c0-1.106-.894-2-2-2zM10 25a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm0-6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm6 6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm0-6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zM30 0H12c-1.106 0-2 .894-2 2v4h14a2 2 0 0 1 2 2v14h4c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/collection-1.js
// module id = 1079
// module chunks = 14